import xss from 'xss';

export default (text) => {
  const whiteList = xss.getDefaultWhiteList();
  ['p', 'ul', 'li', 'ol', 'span'].forEach((element) => {
    whiteList[element].push('style', 'class');
  });

  const myxss = new xss.FilterXSS({ whiteList, css: false });
  return myxss.process(text);
};
